(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-explained"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var placeholder = document.getElementById('about-video-placeholder');
    var container = document.getElementById('about-youtube-container');
    var iframe = document.getElementById('about-youtube-iframe');

    if (placeholder) {
      placeholder.addEventListener('click', function() {
        iframe.src = 'https://www.youtube.com/embed/DsBlB3rsOv0?autoplay=1&rel=0';
        placeholder.style.display = 'none';
        container.style.display = 'block';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var select = document.getElementById('FooterCountry');
    if (!select) return;
    select.addEventListener('change', function () {
      this.form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-allocation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('.promo-allocation__bar');
    if (!bars.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      bars.forEach((bar) => bar.classList.add('is-animated'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => entry.target.classList.add('is-animated'));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    bars.forEach((bar) => observer.observe(bar));
  })();

  } catch(e) { console.error(e); }
})();
})();
